import React from "react";
import { Box, Typography, Button } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";

import default_theme from "assets/themes/themes";

const SolutionDetailSidebarInfo = ({
    data,
    styles,
    websiteLabel = "Visit Project Website",
}) => {
    return (
        <>
            {(data.location_town ||
                data.location_region ||
                data.location_country) && (
                <Box className={styles.detailItem}>
                    <Typography
                        sx={{ fontWeight: "bold" }}
                        variant="h6"
                        color="text.secondary"
                    >
                        Location
                    </Typography>

                    <Typography variant="body1" fontWeight={500}>
                        {[
                            data.location_town,
                            data.location_region,
                            data.location_country,
                        ]
                            .filter(Boolean)
                            .join(", ")}
                    </Typography>
                </Box>
            )}

            {data.lead_org_name && (
                <Box className={styles.detailItem}>
                    <Typography
                        sx={{ fontWeight: "bold" }}
                        variant="h6"
                        color="text.secondary"
                    >
                        Organization
                    </Typography>

                    <Typography variant="body1" fontWeight={500}>
                        {data.lead_org_name}
                    </Typography>

                    {data.lead_org_type && (
                        <Typography variant="body2" color="text.secondary">
                            {data.lead_org_type}
                        </Typography>
                    )}
                </Box>
            )}

            {data.website && (
                <Box className={styles.detailItem}>
                    <Typography
                        sx={{ fontWeight: "bold" }}
                        variant="h6"
                        color="text.secondary"
                    >
                        Website
                    </Typography>

                    <Button
                        href={data.website}
                        target="_blank"
                        size="small"
                        startIcon={<LanguageIcon />}
                        sx={{
                            textTransform: "none",
                            p: 0,
                            justifyContent: "flex-start",
                            color: default_theme.palette.other.main,
                        }}
                    >
                        {websiteLabel}
                    </Button>
                </Box>
            )}

            {(data.competencies_required || data.beneficiaries) && (
                <>
                    {data.competencies_required && (
                        <Box className={styles.detailItem}>
                            <Typography
                                sx={{ fontWeight: "bold" }}
                                variant="h6"
                                color="text.secondary"
                            >
                                Required Competencies
                            </Typography>

                            <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                                {data.competencies_required}
                            </Typography>
                        </Box>
                    )}

                    {data.beneficiaries && (
                        <Box className={styles.detailItem}>
                            <Typography
                                sx={{ fontWeight: "bold" }}
                                variant="h6"
                                color="text.secondary"
                            >
                                Target Beneficiaries
                            </Typography>

                            <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                                {data.beneficiaries}
                            </Typography>
                        </Box>
                    )}
                </>
            )}
        </>
    );
};

export default SolutionDetailSidebarInfo;